import React from "react";
import { FaChartBar, FaGraduationCap } from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { Section } from "../../Common/Styles/containers";
import { IScormPackage } from "../../types/common";
import * as utils from "../utils";

const Title = styled.h3`
  margin: 0.5rem 0;
`;

const Value = styled.div`
  margin: 0.5rem 0;
`;

const EntryContainer = styled.div`
  margin: 1rem 0;
`;

const CustomLink = styled(Link)`
  color: ${({ theme }) => theme.colors.black};
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`;

const CustomGraduationCap = styled(FaGraduationCap)`
  color: ${({ theme }) => theme.colors.darkblue};
`;

interface IEntryProps {
  title: string;
}

const Entry: React.SFC<IEntryProps> = ({ title, children }) => (
  <EntryContainer>
    <Title>{title}</Title>
    <Value>{children}</Value>
  </EntryContainer>
);

interface ISummaryProps {
  courseName: string;
  scormPackage: IScormPackage;
}

const Summary: React.FC<ISummaryProps> = ({ courseName, scormPackage }) => {
  return (
    <Section>
      <Entry title="Course">
        <CustomLink to={`/course-author/${scormPackage.courseId}`}>
          <CustomGraduationCap /> {courseName}
        </CustomLink>
      </Entry>
      <Entry title="Analytics">
        <CustomLink to={`/analytics/scormPackage/${scormPackage.courseId}/${scormPackage.scormPackageId}`}>
          <FaChartBar /> {scormPackage.name}
        </CustomLink>
      </Entry>
      <Entry title="LMS Navigation bar">{utils.navigationBarMsg(scormPackage.hideLmsNavbar)}</Entry>
      <Entry title="Scorm version">{utils.scormVersionMsg(scormPackage.scormVersion)}</Entry>
      <Entry title="LMS">{utils.lmsNameMsg(scormPackage.lms)}</Entry>
    </Section>
  );
};

export default Summary;
